<template>
    <div class="consultingNews">
        <Title></Title>
        <div class="content">
            <div class="content-left" @click="goNewsDetail(0)">
                <img v-lazy="news" alt="">
                <div class="time">
                    <div>{{ newsList[0].time.substring(0, 4) }}</div>
                    <span>{{ newsList[0].time.substring(5) }}</span>
                </div>
                <div class="bottom">
                    <h2 class="content-left-title">{{ newsList[0].title }}</h2>
                    <span>{{ newsList[0].content }}</span>
                </div>
            </div>
            <div class="content-right">
                <div class="content-right-item" v-for="(item, index) in newsList" :key="index" v-show="index !== 0"
                    @click="goNewsDetail(index)">
                    <div class="content-right-item-left">
                        <div style="display: flex;flex-direction: column;align-items: center;">
                            <span>{{ item.time.substring(5) }}</span>
                            <span>{{ item.time.substring(0, 4) }}</span>
                        </div>
                        <span class="line"></span>
                    </div>
                    <div class="content-right-item-right">
                        <h2>{{ item.title }}</h2>
                        <span>{{ item.content }}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import qiMo from '@/assets/images/news/qimo.png'
import yixienzhen from '@/assets/images/news/yixienzhen.png'
import one from '@/assets/images/news/one.png'
import two from '@/assets/images/news/two.png'
import three from '@/assets/images/news/three.png'
import four from '@/assets/images/news/four.png'
import { ref, onMounted } from 'vue';
import news from '@/assets/images/index/news.png';
import { useRouter } from 'vue-router';
const router = useRouter();
onMounted(() => {
    localStorage.setItem('newsList', JSON.stringify(newsList.value))
})
const newsList = ref([
    {
        url: yixienzhen,
        title: '溢希恩真与大云端科技：母公司与子公司的协同创新之路',
        time: '2025-2-27',
        content: '在当今科技飞速发展的时代，企业间的协同合作与资源共享已成为推动行业进步的核心动力。溢希恩真与大云端科技的关系正是这种协同创新的典范。作为大云端科技的母公司，溢希恩真不仅在技术上为其提供了坚实的支持，更在战略和资源上推动了大云端科技的快速发展，共同谱写了智能制造与绿色节能的新篇章。'
    },
    {
        url: qiMo,
        title: '大云端科技出席重庆汽摩协会理事会年会，助力汽摩行业高质量发展',
        time: '2025-1-17',
        content: '1月14日，重庆汽车摩托车行业协会理事会暨年度工作会在重庆大坪万友康年大酒店隆重召开。大云端科技受邀出席，与政府领导、协会负责人，以及整车制造企业、零部件制造企业的高管和技术专家等200余位嘉宾齐聚一堂，共同探讨汽摩行业发展的新方向，以及数字化转型的创新路径。'
    },
    {
        url: one,
        title: '四部门联合发布《中小企业数字化赋能专项行动方案（2025—2027年）》',
        time: '2024-12-17',
        content: '近日，工业和信息化部、财政部、中国人民银行、金融监管总局四部门联合发布了《中小企业数字化赋能专项行动方案（2025—2027年）》（以下简称《方案》），旨在进一步推动中小企业数字化转型，促进中小企业专精特新发展。'
    },
    {
        url: two,
        title: '工业AI：从“制”造到“智”造，效率翻倍不是梦！',
        time: '2024-12-13',
        content: '伴随着人工智能技术井喷式发展及国家新型工业化的战略驱动，工业领域正经历着一场前所未有的智能化革命。新型工业化浪潮中，工业人工智能（Industrial AI）正成为推动制造业革新的核心动力。这不仅是技术革新的重要节点，更是工业AI从理论走向实践、从实验室迈向生产线深度融合的新篇章。'
    },
    {
        url: three,
        title: '精彩亮相！大云端科技积极参与2024中国精密高速成形及深拉深技术研讨会',
        time: '2024-12-06',
        content: ' 2024年12月4日至6日，由中国锻压协会主办的“2024中国精密高速成形及深拉技术研讨会”在浙江宁波成功举办。本次会议以“新技术新装备，赋能新质生产力”为主题，汇聚了行业内的专家学者和企业代表，共同探讨精密高速冲压和深拉深技术的最新进展和未来方向。作为工业AI领域的创新推动者，大云端科技积极参会，与参会嘉宾深入交流，聚焦工业AI技术在推动企业数字化转型中的关键作用。'
    },

])
// 去往新闻详情
const goNewsDetail = (index) => {
    router.push({
        path: '/consulting-news/detail',
        query: {
            'index': index
        }
    })
}
</script>

<style scoped lang="less">
.consultingNews {
    width: 100%;
    margin-top: 6.25rem;
    padding-left: 15.3125rem;
    padding-right: 15.3125rem;
    text-align: left;
}

.content {
    width: 100%;
    height: 33.5rem;
    display: flex;

    .content-left {
        position: relative;
        transition: all .5s;

        &:hover {
            transform: scale(1.04);
        }

        img {
            width: 37.8125rem;
            height: 100%;
            z-index: 1;

        }

        .time {
            position: absolute;
            top: 0;
            right: 0;
            width: 7rem;
            height: 7rem;
            background: #0053A3;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            color: #fff;
            font-size: 1.25rem;

            div {
                font-size: 2.125rem;
                font-weight: bold;
            }
        }

        .bottom {
            width: 100%;
            height: 7.5rem;
            background: #000;
            position: absolute;
            bottom: 0;
            left: 0;
            opacity: 0.6;
            padding-left: 1rem;
            padding-right: 1rem;

            .content-left-title {
                font-size: 1.25rem;
                color: #FFFFFF;
                margin-top: 1rem;
                margin-bottom: .5rem;
            }

            span {
                font-size: .875rem;
                margin-top: .75rem;
                color: #fff;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                /* 显示3行 */
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .content-right {
        flex: 1;
        border-right: .0625rem solid #E5E5E5;
        padding-left: 2.125rem;
        padding-right: 2.125rem;
        overflow-y: scroll;

        .content-right-item {
            width: 100%;
            height: 33.33%;
            // background-color: pink;
            border-bottom: .125rem solid #E5E5E5;
            padding-top: 2.75rem;
            display: flex;
            transition: all .5s;

            &:hover {
                transform: scale(1.04);

                .content-right-item-left {

                    span:nth-child(3) {
                        opacity: 1;
                    }
                }

            }

            .content-right-item-left {
                height: 100%;
                width: 6.875rem;
                position: relative;
                transition: all .5s;


                span {
                    text-align: left;
                    display: block;

                    &:nth-child(1) {
                        font-size: 2.125rem;
                        font-weight: bold;
                    }

                    &:nth-child(2) {
                        font-size: 1.25rem;
                        color: #777777;

                    }

                    &:nth-child(3) {
                        transition: all .5s;
                        opacity: 0;
                        font-size: 1.25rem;
                        width: 3.375rem;
                        height: .25rem;
                        background-color: @xtxColor;
                        position: absolute;
                        bottom: -2px;

                    }
                }
            }

            .content-right-item-right {
                flex: 1;
                transition: all .5s;

                h2 {
                    font-size: 1.25rem;
                    font-weight: bold;
                    margin-bottom: 1.75rem;
                }

                span {
                    display: block;
                    font-size: .875rem;
                    line-height: 1.625rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    /* 显示3行 */
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
</style>